export default "__VITE_ASSET__DRF_poje__"